/**
 * Created by iggy on 10/21/16.
 */

(function () {
    'use strict';

    // @ngInject
    function WelcomeLeadControllerCtor($modalInstance, $scope, AnalyticsService, UsersManager) {

        this.$modalInstance = $modalInstance;
        this.__objectType = 'WelcomeLeadController';

        var trackingStr = 'welcome lead';
        AnalyticsService.trackPageView(this, trackingStr);


        this.user = UsersManager.getCurrUser();
    }

    Controllers.WelcomeLeadController = Class(Controllers.BaseController, {
        constructor: WelcomeLeadControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        }

    });
}());